import { useEffect, useState } from 'react';
import { WindowSize } from 'app/CasinoGames/types';
import { Fullscreen } from './useFullscreen';

const sidebarHeight = 42;
const resizeDelay = 100;
const screenFullness = 0.96;

export const fitToBox = (windowSize: WindowSize, box: WindowSize): WindowSize => {
  const floorbox = {
    width: Math.floor(box.width),
    height: Math.floor(box.height) - sidebarHeight,
  };
  const widthCoef = floorbox.width / windowSize.width;
  const heightCoef = floorbox.height / windowSize.height;

  const coef = Math.min(heightCoef, widthCoef);
  const width = Math.floor(windowSize.width * coef);
  const height = Math.floor(windowSize.height * coef);

  return { width, height };
};

const dimensions = (container: Container, windowSize: WindowSize, fullscreen: Fullscreen) => {
  const currentFullness = fullscreen.enabled ? 1.0 : screenFullness;
  return fitToBox(windowSize, {
    width: container.innerWidth * currentFullness,
    height: container.innerHeight * currentFullness,
  });
};

type GameSize = { uiSize: WindowSize; contentSize: WindowSize };

type Container = Pick<Window, 'innerWidth' | 'innerHeight'>;

const useGameSize = (container: Container, windowSize: WindowSize, fullscreen: Fullscreen): GameSize => {
  const [fit, setFit] = useState<WindowSize>(dimensions(container, windowSize, fullscreen));
  const [timeoutID, setTimeoutID] = useState<NodeJS.Timeout>();

  useEffect(() => {
    const onResizeWindow = () => {
      if (timeoutID) clearTimeout(timeoutID);
      setTimeoutID(
        setTimeout(() => {
          setFit(dimensions(container, windowSize, fullscreen));
        }, resizeDelay)
      );
    };

    window.addEventListener('resize', onResizeWindow);

    return () => {
      window.removeEventListener('resize', onResizeWindow);
    };
  }, []);

  const uiSize = {
    width: fit.width,
    height: fit.height + sidebarHeight,
  };

  const contentSize = {
    width: fit.width,
    height: fit.height,
  };

  return { uiSize, contentSize };
};

export default useGameSize;
